import Condense from "./condense.svg";

export default Condense;
